export default __webpack_public_path__ + "static/media/warning.cfbdbf5c.svg";